<template>
    <div class="enterprise-page" v-loading="pageLoading">
        <!-- 企业基本信息卡片 -->
        <div class="whitebox centerpage py-4">
            <div class="d_blocktitle">
                <i class="title-icon fl el-icon-office-building"></i>
                <h3 class="ctitle">{{ companyinfor.enterprise_name }}</h3>
            </div>
            <ul class="oh conpany-infor-new">
                <li class="inforLine inforLine-3">
                    <span class="label">注册资金：</span>
                    <span class="infortext">{{ companyinfor.register_amount + companyinfor.currency_kind_name || '-'
                        }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">注册机构：</span>
                    <span class="infortext">{{ companyinfor.registration_organization_name || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">企业类型：</span>
                    <span class="infortext">{{ companyinfor.economic_type_name || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">法定代表人：</span>
                    <span class="infortext">{{ companyinfor.legal_person_name || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3" v-show="companyinfor.isIpo">
                    <span class="label">上市时间：</span>
                    <span class="infortext">{{ companyinfor.ipoTime || '-' }}</span>
                </li>
                <!-- <li class="inforLine inforLine-3" v-show="companyinfor.isIpo">
                    <span class="label">A股代码：</span>
                    <span class="infortext">{{ companyinfor.stockCode || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3" v-show="companyinfor.abbr">
                    <span class="label">股票简称：</span>
                    <span class="infortext">{{ companyinfor.abbr }}</span>
                </li>-->
                <li class="inforLine inforLine-3">
                    <span class="label">注册号：</span>
                    <span class="infortext">{{ companyinfor.register_number || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">纳税人识别号：</span>
                    <span class="infortext">{{ companyinfor.taxpayer_identify_number || '-' }}</span>
                </li>
                <li class="inforLine inforLine-3">
                    <span class="label">所属行业：</span>
                    <span class="infortext">{{ companyinfor.neic_class || companyinfor.neic_section ||
                        companyinfor.neic_group || companyinfor.neic_division || '-' }}</span>
                </li>
                <!-- <li class="inforLine inforLine-3 longlabel" v-if="realController.length > 0">
                    <span class="label">疑似实际控制人：</span>
                    <span class="infortext">{{ realController[0].title }}</span>
                </li>  -->
                <!-- <li class="inforLine inforLine-3" v-if="realController.length > 0">
                    <span class="label">总股权比例：</span>
                    <span class="infortext">{{ realController[0].proportion }}</span>
                </li> -->
                <!-- <li class="inforLine inforLine-one" v-show="extendinfor.coreProduct">
                    <span class="label">企业核心产品：</span>
                    <el-tag effect="plain" class="mr-1" v-for="(item, i) in productlist" :key="i">{{ item }}</el-tag>
                </li> -->
                <li class="inforLine inforLine-one">
                    <span class="label">企业地址：</span>
                    <span class="infortext">{{ companyinfor.register_address || '-' }}</span>
                </li>
                <li class="inforLine inforLine-one">
                    <span class="label">主营产品名称：</span>
                    <span class="infortext">{{ companyinfor.product_name || '-' }}</span>
                </li>
                <li class="inforLine inforLine-one">
                    <span class="label">主营产品类型：</span>
                    <span class="infortext">{{ companyinfor.product_class || '-' }}</span>
                </li>
                <li class="inforLine inforLine-one" v-show="companyinfor.corporation_scope">
                    <span class="label">主营业务：</span>
                    <span class="infortext">{{ companyinfor.corporation_scope }}</span>
                </li>
                <li class="inforLine inforLine-one"
                    v-if="companyinfor.enterprise_brief && companyinfor.enterprise_brief.length > 0">
                    <span class="label">企业简介：</span>
                    <span class="infortext">{{ companyinfor.enterprise_brief }}</span>
                </li>
            </ul>
        </div>

        <!-- 楼层导航（吸顶） -->
        <div class="floor-nav-wrapper" :class="{ 'is-sticky': isSticky }" ref="floorNav">
            <div class="floor-nav">
                <div v-for="floor in floorList" :key="floor.id" class="floor-nav-item"
                    :class="{ active: activeFloor === floor.id }" @click="scrollToFloor(floor.id)"
                    @mouseenter="hoverFloor = floor.id" @mouseleave="hoverFloor = null">
                    <span class="floor-name">{{ floor.name }}</span>

                    <!-- 子菜单悬浮面板 -->
                    <transition name="fade">
                        <div v-show="hoverFloor === floor.id" class="submenu-panel">
                            <div v-for="sub in floor.children" :key="sub.id" class="submenu-item" :class="!sub.component?'enmpty':''"
                                @click.stop="scrollToSubSection(floor.id, sub.id)">
                                {{ sub.name }}
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>

        <!-- 楼层内容区域 -->
        <div class="floor-content-wrapper">
            <div v-for="floor in floorList" :key="floor.id" :id="floor.id" class="floor-section">
                <div class="floor-header">
                    <div class="floor-title-bar">
                        <i class="floor-icon"></i>
                        <h3>{{ floor.name }}</h3>
                    </div>
                </div>

                <!-- 子模块内容 -->
                <div v-for="sub in floor.children" :key="sub.id" :id="sub.id" class="sub-section">
                    <div class="sub-section-title">{{ sub.name }}</div>
                    <div class="sub-section-content">
                        <!-- 各子模块对应组件 -->
                        <component :is="sub.component" v-if="sub.component" :moduleData="getModuleData(sub.id)" />
                        <div v-else class="placeholder-content">
                            <p>{{ sub.name }} 内容区域</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 右侧快速返回顶部 -->
        <div class="back-to-top" v-show="showBackTop" @click="scrollToTop">
            <i class="el-icon-arrow-up"></i>
            <span>顶部</span>
        </div>
    </div>
</template>

<script>
import classificationTags from './enterpriseInc/classificationTags.vue'; // 分类标签
import taxCreditRating from './enterpriseInc/taxCreditRating.vue'; // 纳税信用等级
import annualReportList from './enterpriseInc/annualReportList.vue'; // 企业年报
import courtBulletinList from './enterpriseInc/courtBulletinList.vue'; // 法院公告
import filingList from './enterpriseInc/filingList.vue'; // 立案信息
import hearingBulletinList from './enterpriseInc/hearingBulletinList.vue'; // 开庭公告
import refereeDocumentList from './enterpriseInc/refereeDocumentList.vue'; // 裁判文书
import finalVersionCaseList from './enterpriseInc/finalVersionCaseList.vue'; // 终本案件
import restrictHighConsumeList  from './enterpriseInc/restrictHighConsumeList.vue'; // 限制高消费
import executeeList from './enterpriseInc/executeeList.vue'; // 被执行人
import dishonestExecuteeList from './enterpriseInc/dishonestExecuteeList.vue'; // 失信被执行人
import judicialAuctionList from './enterpriseInc/judicialAuctionList.vue'; // 司法拍卖
import judicialAssistList from './enterpriseInc/judicialAssistList.vue'; // 司法协助
import bankruptReformList from './enterpriseInc/bankruptReformList.vue'; // 破产重组
import licenseList from './enterpriseInc/licenseList.vue'; // 行政许可
import certificationList from './enterpriseInc/certificationList.vue'; //资质证书
import techAchievementList from './enterpriseInc/techAchievementList.vue'; //// 科技成果
import standardList from './enterpriseInc/standardList.vue'; // 标准信息
import equityPledgeList from './enterpriseInc/equityPledgeList.vue'; // 股权质押
import sanctionList from './enterpriseInc/sanctionList.vue'; // 行政处罚
import violationEventList  from './enterpriseInc/violationEventList.vue'; // 违法事件
import taxArrearsList from './enterpriseInc/taxArrearsList.vue'; // 欠税信息
export default {
    components: { classificationTags,taxCreditRating,annualReportList,courtBulletinList,filingList,hearingBulletinList,
        refereeDocumentList ,finalVersionCaseList,restrictHighConsumeList,executeeList,dishonestExecuteeList,judicialAuctionList,
        judicialAssistList,bankruptReformList,licenseList,certificationList,techAchievementList,standardList,equityPledgeList,sanctionList,
        violationEventList,taxArrearsList
    },
    data() {
        return {
            id: this.$route.query.id || null,
            companyinfor: {},
            pageLoading: false,
            detailData: {},
            // 楼层导航数据
            floorList: [
                {
                    id: 'baseInfo',
                    name: '基本信息',
                    children: [
                        // { id: 'contactVIP', name: '联系人VIP', component: null },
                        { id: 'classificationTags', name: '分类标签', component: 'classificationTags' },
                        { id: 'taxCreditRating', name: '纳税信用等级', component: 'taxCreditRating' },
                        { id: 'annualReportList', name: '企业年报', component: 'annualReportList' },
                        // { id: 'changeRecord', name: '变更记录', component: null },
                    ]
                },
                {
                    id: 'personnel',
                    name: '人员信息',
                    children: [
                        // { id: 'employees', name: '从业人员', component: null },
                        // { id: 'keyPersonnel', name: '主要人员', component: null },
                        // { id: 'executives', name: '高管信息', component: null },
                        // { id: 'historyExecutives', name: '历史高管', component: null },
                    ]
                },
                {
                    id: 'equity',
                    name: '股权关系',
                    children: [
                        // { id: 'beneficiary', name: '受益人信息', component: null },
                        // { id: 'controller', name: '实际控制人', component: null },
                        // { id: 'shareholders', name: '股东信息', component: null },
                        // { id: 'branches', name: '分支机构', component: null },
                        // { id: 'investment', name: '对外投资', component: null },
                    ]
                },
                {
                    id: 'projects',
                    name: '项目信息',
                    children: [
                        // { id: 'landInfo', name: '拿地信息', component: null },
                        // { id: 'projectApproval', name: '项目审批', component: null },
                        // { id: 'biddingNotice', name: '招投标公告', component: null },
                        // { id: 'biddingResult', name: '招投标结果', component: null },
                        // { id: 'biddingRelation', name: '招投标关系', component: null },
                        // { id: 'biddingText', name: '招投标正文', component: null },
                    ]
                },
                {
                    id: 'business',
                    name: '经营信息',
                    children: [
                        { id: 'licenseList', name: '行政许可', component: 'licenseList' },
                        { id: 'certificationList', name: '资质证书', component: 'certificationList' },
                        { id: 'techAchievementList', name: '科技成果', component: 'techAchievementList' },
                        { id: 'standardList', name: '标准信息', component: 'standardList' },
                    ]
                },
                {
                    id: 'businessRisk',
                    name: '经营风险',
                    children: [
                        { id: 'equityPledgeList', name: '股权质押', component: 'equityPledgeList' },
                        { id: 'sanctionList', name: '行政处罚', component: 'sanctionList' },
                        { id: 'violationEventList', name: '违规事件', component: 'violationEventList' },
                        { id: 'taxArrearsList', name: '欠税信息', component: 'taxArrearsList' },
                    ]
                },
                {
                    id: 'judicial',
                    name: '司法信息',
                    children: [
                        { id: 'courtBulletinList', name: '法院公告', component: 'courtBulletinList' },
                        { id: 'filingList', name: '立案信息', component: 'filingList' },
                        { id: 'hearingBulletinList', name: '开庭公告', component: 'hearingBulletinList' },
                        { id: 'refereeDocumentList', name: '裁判文书', component: 'refereeDocumentList' },
                        { id: 'finalVersionCaseList', name: '终本案件', component: 'finalVersionCaseList' },
                    ]
                },
                {
                    id: 'judicialRisk',
                    name: '司法风险',
                    children: [
                        { id: 'restrictHighConsumeList', name: '限制高消费', component: 'restrictHighConsumeList' },
                        { id: 'executeeList', name: '被执行人', component: 'executeeList' },
                        { id: 'dishonestExecuteeList', name: '失信被执行人', component: 'dishonestExecuteeList' },
                        { id: 'judicialAuctionList', name: '司法拍卖', component: 'judicialAuctionList' },
                        { id: 'judicialAssistList', name: '司法协助', component: 'judicialAssistList' },
                        { id: 'bankruptReformList', name: '破产重组', component: 'bankruptReformList' },
                    ]
                }
            ],

            activeFloor: 'baseInfo',
            hoverFloor: null,
            isSticky: false,
            showBackTop: false,
            navOffsetTop: 0,
            scrollTimer: null,

            // --- 新增修复变量 ---
            scrollContainer: null,       // 真正产生滚动条的容器元素
            fixedHeaderHeight: 200,      // 顶部固定 Header 的高度 (对应CSS里的 top: 200px)
            navBarHeight: 56             // 导航栏自身高度 (对应CSS里的 height: 56px)
        }
    },
    computed: {
        // 预先把各模块数据整理好，不会每次渲染都新建对象,否则重新渲染回导致楼层滚动出错
        moduleDataMap() {
            const d = this.detailData || {};
            const basicInfo = d.basicInfo || {};
            const operatingInfo = d.operatingInfo || {};
            const legalRisk = d.legalRisk || {};
            return {
                classificationTags: basicInfo.tagsList || [],
                taxCreditRating: operatingInfo.taxPaymentRatingsList || [],
                annualReportList: basicInfo.annualReportList || [],
                courtBulletinList: legalRisk.courtBulletinList || [],
                filingList: legalRisk.filingList || [],
                hearingBulletinList: legalRisk.hearingBulletinList || [],
                refereeDocumentList: legalRisk.refereeDocumentList || [],
                finalVersionCaseList: legalRisk.finalVersionCaseList || [],
                restrictHighConsumeList: legalRisk.restrictHighConsumeList || [],
                executeeList: legalRisk.executeeList || [],
                dishonestExecuteeList: legalRisk.dishonestExecuteeList || [],
                judicialAuctionList: legalRisk.judicialAuctionList || [],
                judicialAssistList: legalRisk.judicialAssistList || [],
                bankruptReformList  : legalRisk.bankruptReformList || [],
                licenseList: operatingInfo.licenseList || [],
                certificationList: operatingInfo.certificationList || [],
                techAchievementList: operatingInfo.techAchievementList || [],
                standardList: operatingInfo.standardList || [],
                equityPledgeList: operatingInfo.equityPledgeList || [],
                sanctionList: operatingInfo.sanctionList || [],
                violationEventList: operatingInfo.violationEventList || [],
                taxArrearsList: operatingInfo.taxArrearsList || [],
                // 其他模块...
            };
        }
    },

    mounted() {
        this.getEnterpriseBaseInfo();
        this.$nextTick(() => {
            this.initScrollListener();
        });
    },

    // 必须开启销毁钩子，移除监听，防止路由切换后页面报错和内存泄漏
    beforeDestroy() {
        this.removeScrollListener();
        if (this.scrollTimer) clearTimeout(this.scrollTimer);
    },

    methods: {
        // 获取模块传给子组件的数据
        getModuleData(subId) {
            return this.moduleDataMap[subId] || {};
        },
        // 获取企业基本信息
        getEnterpriseBaseInfo() {
            const ajaxUrl = this.$api.common.constructionUnit.EnterpriseBaseInfo() + '?unitId=' + this.id;
            this.pageLoading = true;
            this.$axios.get(ajaxUrl).then(res => {
                console.log('企业基本信息', res);
                if (res.success) {
                    this.companyinfor = res.data || {};
                    this.getEnterpriseDetail(this.companyinfor.enterprise_id);
                    this.pageLoading = false;
                }else {
                    this.pageLoading = false;
                    this.$message.error(res.msg);
                }
            });
        },

        getEnterpriseDetail(enterpriseId) {
            const ajaxUrl = this.$api.common.constructionUnit.EnterpriseDetail() + '?enterpriseId=' + enterpriseId;
            this.$axios.get(ajaxUrl).then(res => {
                console.log('企业详情', res);
                if (res.success) {
                    this.detailData = res.data || {};
                    this.pageLoading = false;
                }
            }).catch(() => {
                this.pageLoading = false;
            });
        },

        // ==========================================
        // 核心：滚动监听相关修复逻辑
        // ==========================================

        // 初始化滚动监听（解决后台系统滚动条不在 window 上的问题）
        initScrollListener() {
            if (!this.$refs.floorNav) return;

            // 1. 获取导航栏距离页面【绝对顶部】的距离，不受父级 position:relative 影响
            this.navOffsetTop = this.$refs.floorNav.getBoundingClientRect().top + window.pageYOffset;

            // 2. 向上查找真正的滚动容器（解决若依等后台框架外层div滚动的问题）
            let node = this.$el.parentElement;
            while (node && node !== document.body) {
                const style = window.getComputedStyle(node);
                if (['auto', 'scroll'].includes(style.overflowY) && node.scrollHeight > node.clientHeight) {
                    this.scrollContainer = node;
                    break;
                }
                node = node.parentElement;
            }
            // 如果没找到带有滚动条的父级，说明是整个页面在滚动，降级使用 window
            if (!this.scrollContainer) {
                this.scrollContainer = window;
            }

            // 3. 绑定监听 { passive: true } 可以提升滚动性能
            this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });
        },

        // 移除滚动监听
        removeScrollListener() {
            if (this.scrollContainer) {
                this.scrollContainer.removeEventListener('scroll', this.handleScroll);
            }
        },

        // 兼容获取当前滚动距离
        getScrollTop() {
            if (this.scrollContainer === window) {
                return window.pageYOffset || document.documentElement.scrollTop;
            }
            return this.scrollContainer.scrollTop;
        },

        // 滚动到指定楼层
        scrollToFloor(floorId) {
            const element = document.getElementById(floorId);
            if (element) {
                // 统一偏移量逻辑：顶部固定高度 + 导航栏高度
                const offset = this.fixedHeaderHeight + this.navBarHeight;
                const scrollTop = this.getScrollTop();
                const top = element.getBoundingClientRect().top + scrollTop - offset;

                this.scrollContainer.scrollTo({ top, behavior: 'smooth' });
                this.activeFloor = floorId;
            }
        },

        // 滚动到指定子模块
        scrollToSubSection(floorId, subId) {
            const element = document.getElementById(subId);
            if (element) {
                // 统一偏移量逻辑：顶部固定高度 + 导航栏高度 + 一点视觉缓冲
                const offset = this.fixedHeaderHeight + this.navBarHeight + 10;
                const scrollTop = this.getScrollTop();
                const top = element.getBoundingClientRect().top + scrollTop - offset;

                this.scrollContainer.scrollTo({ top, behavior: 'smooth' });
                this.activeFloor = floorId;
                this.hoverFloor = null; // 收起悬浮面板
            }
        },

        // 滚动监听回调
        handleScroll() {
            const scrollTop = this.getScrollTop();

            // 吸顶判断
            this.isSticky = scrollTop >= this.navOffsetTop;

            // 返回顶部显示
            this.showBackTop = scrollTop > 500;

            // 防抖：避免高频滚动计算导致卡顿
            if (this.scrollTimer) clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
                this.updateActiveFloor();
            }, 50); // 调整为 50ms，高亮切换会更灵敏
        },

        // 更新当前激活的楼层（重构，彻底抛弃 offsetTop）
        updateActiveFloor() {
            // 视口偏移量阈值：只要楼层的顶部触碰到这个线，就认为进入了该楼层
            const threshold = this.fixedHeaderHeight + this.navBarHeight;

            for (let i = this.floorList.length - 1; i >= 0; i--) {
                const el = document.getElementById(this.floorList[i].id);
                if (el) {
                    // 核心修复：getBoundingClientRect().top 获取相对于【视口】的距离
                    // 这个值永远准确，不受外层任何 position 定位的干扰
                    if (el.getBoundingClientRect().top <= threshold) {
                        this.activeFloor = this.floorList[i].id;
                        break;
                    }
                }
            }
        },

        // 返回顶部
        scrollToTop() {
            this.scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
        }
    }
}
</script>

<style lang="scss" scoped>
.enterprise-page {
    background: #f5f7fa;
    min-height: 100vh;
}
.enmpty{
    color: #999 !important;
    cursor: default‌ !important;
}

/* ===== 楼层导航样式 ===== */
.floor-nav-wrapper {
    background: #fff;
    border-bottom: 1px solid #e8ecf1;
    position: relative;
    z-index: 100;
    transition: all 0.3s ease;

    &.is-sticky {
        position: fixed;
        top: 60px;
        left: 0;
        right: 0;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    }
}

.floor-nav {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 56px;
}

.floor-nav-item {
    flex: 1;
    text-align: center;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    font-size: 15px;
    color: #555;
    font-weight: 500;
    transition: all 0.2s ease;
    border-bottom: 3px solid transparent;

    &:hover {
        color: #1a73e8;
        background: #f8fafc;
    }

    &.active {
        color: #1a73e8;
        border-bottom-color: #1a73e8;
        font-weight: 600;
    }

    .floor-name {
        pointer-events: none;
    }
}

/* 子菜单悬浮面板 */
.submenu-panel {
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    border: 1px solid #e8ecf1;
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    padding: 8px 0;
    min-width: 140px;
    z-index: 200;
    margin-top: 3px;

    &::before {
        content: '';
        position: absolute;
        top: -6px;
        left: 50%;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #fff;
    }
}

.submenu-item {
    padding: 10px 20px;
    font-size: 13px;
    color: #555;
    white-space: nowrap;
    cursor: pointer;
    transition: all 0.15s ease;

    &:hover {
        background: #f0f7ff;
        color: #1a73e8;
    }
}

/* 过渡动画 */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s, transform 0.2s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
    transform: translateX(-50%) translateY(-5px);
}

/* ===== 楼层内容区域 ===== */
.floor-content-wrapper {
    margin: 0 auto;
    padding: 24px 0 60px;
}

.floor-section {
    margin-bottom: 24px;
    background: #fff;
    border-radius: 8px;
    padding: 24px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.floor-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #f0f0f0;
}

.floor-title-bar {
    display: flex;
    align-items: center;

    .floor-icon {
        width: 4px;
        height: 18px;
        background: #1a73e8;
        border-radius: 2px;
        margin-right: 10px;
    }

    h3 {
        font-size: 18px;
        font-weight: 600;
        color: #1a1a1a;
        margin: 0;
    }
}

.sub-section {
    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 0;
    }
}

.sub-section-title {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    padding-left: 12px;
    border-left: 3px solid #1a73e8;
}

.sub-section-content {
    background: #fafbfc;
    border-radius: 6px;
    padding: 20px;
    min-height: 120px;
}

.placeholder-content {
    color: #999;
    text-align: center;
    padding: 40px 0;

    p {
        margin: 0;
        font-size: 14px;
    }
}

/* 返回顶部 */
.back-to-top {
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 48px;
    height: 48px;
    background: #fff;
    border-radius: 50%;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 999;
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);

        i,
        span {
            color: #1a73e8;
        }
    }

    i {
        font-size: 16px;
        color: #666;
        margin-bottom: 2px;
    }

    span {
        font-size: 11px;
        color: #666;
    }
}

/* 吸顶时的内容补偿 */
.is-sticky+.floor-content-wrapper {
    padding-top: 72px;
}

/* 响应式 */
@media (max-width: 768px) {
    .floor-nav {
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        .floor-nav-item {
            flex: 0 0 auto;
            padding: 0 16px;
            font-size: 14px;
        }
    }

    .conpany-infor-new .inforLine.inforLine-3 {
        width: 50%;
    }
}
</style>